export default function reducer(state, action) {
  switch (action.type) {
    case 'FETCH_SALARYTYPES_PENDING':
      return {
        ...state,
        loadingSalaryTypes : true,
        salaryTypesFetched : false,
        error              : false,
      }
    case 'FETCH_SALARYTYPES_FULFILLED':
      return {
        ...state,
        loadingSalaryTypes : false,
        salaryTypesFetched : true,
        error              : false,
        salaryTypes        : action.payload,
      }
    case 'FETCH_SALARYTYPES_REJECTED':
      return {
        ...state,
        loadingSalaryTypes : false,
        salaryTypesFetched : false,
        error              : true,
      }
    default:
      return state
  }
}
